import { createFileRoute } from '@tanstack/react-router'
import { Helmet } from '@/common/components/Helmet'
import CanonicalLink from '@/common/components/CanonicalLink'
import HgBreadcrumbs from '@/common/components/ui/atoms/HgBreadcrumbs'
import MaterialsListPublic from '@/features/lms/components/MaterialsListPublic'

export const Route = createFileRoute('/app/resources/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Browse free health and wellness resources and trainings from the Alliance for a Healthier Generation to support students, staff, and families at your school."
        />
      </Helmet>
      <CanonicalLink path="/resources" />
      <HgBreadcrumbs
        options={[
          { title: 'Home', link: '/app/account' },
          { title: 'Resources & Trainings', link: null },
        ]}
      />
      <h1>Resources & Trainings</h1>
      <MaterialsListPublic />
    </>
  )
}
